import { render, staticRenderFns } from "./DocumentProductionPrint.vue?vue&type=template&id=506e1dca&scoped=true"
import script from "./DocumentProductionPrint.vue?vue&type=script&lang=js"
export * from "./DocumentProductionPrint.vue?vue&type=script&lang=js"
import style0 from "./DocumentProductionPrint.vue?vue&type=style&index=0&id=506e1dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506e1dca",
  null
  
)

export default component.exports